



















import InfoBlock from './components/InfoBlock.vue';
import { learningOutcomesService } from './service';
import { Component, Vue } from 'vue-property-decorator';
import { Warning, Header } from '@/pages/profile/components';
import { LearningOutcomeItem } from './types';

@Component({
  components: {
    Warning,
    InfoBlock,
    Header,
  },
})
export default class ResultCourses extends Vue {
  private dataItems: Array<LearningOutcomeItem> | void = [];
  private blankImage = './image/blank_sertificate.jpg';

  created() {
    this.getLearningOutcomeItems();
  }

  async getLearningOutcomeItems() {
    this.dataItems = await learningOutcomesService
      .getLearningOutcomes()
      .catch((err: any) => {
        console.warn('service error:', err);
      });
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/views/resultCourses/ResultCourses.vue